export default {
  'pages.markets.subtitle.apps':
    'ビジネスアプリケーションを見つけて有効化し、ワークスペースを強化します。',
  'pages.markets.subtitle.skill':
    '多彩な Skill を探索し、AI アシスタントの機能を拡張します。',
  'pages.markets.subtitle.mcp':
    'MCP サーバーとツールを見つけて連携し、外部連携を拡張します。',
  'pages.markets.subtitle.digital_human':
    '公式デジタルヒューマンを探し、指示と Skill を再利用できます。',
  'pages.markets.subtitle.plugin':
    'Zhiyue クライアント用プラグインを探し、パッケージをダウンロードして機能を拡張します。',
  'pages.markets.tab.apps': 'アプリマーケット',
  'pages.markets.tab.skill': 'Skill マーケット',
  'pages.markets.tab.mcp': 'MCP マーケット',
  'pages.markets.tab.digital_human': 'デジタルヒューマンマーケット',
  'pages.markets.tab.plugin': 'プラグインマーケット',
  'pages.markets.sources': 'ソース',
  'pages.markets.source.all': 'すべて',
  'pages.markets.source.official': '公式',
  'pages.markets.skillsShCountTooltip':
    'skills.sh は合計 {count} 件の Skill を収録しており、ランキング上位 600 件を閲覧できます。',
  'pages.markets.search': '検索',
  'pages.markets.searchPlaceholder.apps': 'アプリ名、説明、開発者を検索...',
  'pages.markets.searchPlaceholder.skill': 'Skill名、機能説明、発行元を検索...',
  'pages.markets.searchPlaceholder.mcp':
    'MCPツール名、機能説明、発行元を検索...',
  'pages.markets.searchPlaceholder.digital_human':
    'デジタルヒューマン名、機能、発行元を検索...',
  'pages.markets.searchPlaceholder.plugin':
    'プラグイン名、コード、説明で検索...',
  'pages.markets.sort.popular': '最も人気',
  'pages.markets.sort.latest': '最新',
  'pages.markets.sort.name': '名前',
  'pages.markets.sort.all_time': '総合',
  'pages.markets.sort.trending': 'トレンド',
  'pages.markets.sort.hot': '人気',
  'pages.markets.sortDisabledWithKeyword': '検索中は並び替えが無効です',
  'pages.markets.categories': 'カテゴリ',
  'pages.markets.all': 'すべて',
  'pages.markets.loadedProgress': '合計 {total} 件中 {loaded} 件読み込み済み',
  'pages.markets.loadedSimple': '{loaded} 件読み込み済み',
  'pages.markets.empty': 'コンテンツがありません',
  'pages.markets.noMatchingResults': '条件に一致する結果が見つかりません',
  'pages.markets.emptyDescription':
    '検索キーワードを変更するか、別のカテゴリを選択してください。',
  'pages.markets.loadError': 'マーケットデータの読み込みに失敗しました',
  'pages.markets.loadErrorDesc':
    '一時的にデータを取得できません。ネットワークを確認して再試行してください。',
  'pages.markets.failedSourcesWarning':
    '以下のソースは一時的に読み込めません: {sources}',
  'pages.markets.retry': '再試行',
  'pages.markets.refresh': '更新',
  'pages.markets.clearFilters': 'フィルターをクリア',
  'pages.markets.loadingMore': '読み込み中...',
  'pages.markets.noMore': 'これ以上はありません',
  'pages.markets.loadMoreRetry': '読み込みに失敗しました。再試行してください',
  'pages.markets.action.open': 'アプリを開く',
  'pages.markets.action.install': 'インストール',
  'pages.markets.action.installed': '開通済み',
  'pages.markets.action.freeActivate': '無料開通',
  'pages.markets.action.paidActivate': '購入して開通',
  'pages.markets.action.contactRequired': '運営にお問い合わせ',
  'pages.markets.action.copyCommand': 'インストールコマンドをコピー',
  'pages.markets.visitHomepage': '公式サイトを開く',
  'pages.markets.viewOnSource': '{source} で表示',
  'pages.markets.codeRepository': 'コードリポジトリ',
  'pages.markets.links': '関連リンク',
  'pages.markets.installCommand': 'インストールコマンド',
  'pages.markets.serviceEndpoint': 'サービスアドレス',
  'pages.markets.thirdPartyDisclaimer':
    'このコンテンツはサードパーティから提供されており、CoralReefによる審査は行われていません。信頼できるソースであることを確認してからインストールしてください。',
  'pages.markets.sourceLabel': 'ソース',
  'pages.markets.versionLabel': 'バージョン',
  'pages.markets.installsLabel': 'インストール数',
  'pages.markets.identifierLabel': '識別子',
  'pages.markets.copy': 'コピー',
  'pages.markets.copySuccess':
    'インストールコマンドをクリップボードにコピーしました',
  'pages.markets.copyEndpointSuccess':
    'サービスアドレスをクリップボードにコピーしました',
  'pages.markets.copyFailed': 'コピーに失敗しました。手動でコピーしてください',
  'pages.markets.unknownPublisher': '不明な発行元',
  'pages.markets.unknownDeveloper': '開発者不明',
  'pages.markets.noDescription': '説明はありません',
  'pages.markets.officialBadge': '公式',
  'pages.markets.featuredBadge': 'おすすめ',
  'pages.markets.verifiedBadge': 'ソース元認証',
  'pages.markets.appBadge': 'アプリ',
  'pages.markets.free': '無料',
  'pages.markets.paid': '有料',
  'pages.markets.pricePending': '価格未定',
  'pages.markets.installs': '{count} 回インストール',
  'pages.markets.downloads': '{count} 回ダウンロード',
  'pages.markets.version': 'v{version}',
  'pages.markets.detailTitle': 'アプリの詳細',
  'pages.markets.description': '説明',
  'pages.markets.developer': '開発者',
  'pages.markets.certification': '認証状況',
  'pages.markets.official': '公式認証',
  'pages.markets.unverified': 'サードパーティ',
  'pages.markets.category': 'カテゴリ',
  'pages.markets.uncategorized': '未分類',
  'pages.markets.price': '価格',
  'pages.markets.previewImages': 'プレビュー',
  'pages.markets.noPreview': 'プレビュー画像はありません',
  'pages.markets.previewAlt': '{name} プレビュー {index}',
  'pages.markets.confirmFreeTitle': '無料開通の確認',
  'pages.markets.confirmFreeDescription':
    'アプリ「{name}」を開通しますか？開通後はワークスペースで使用できます。',
  'pages.markets.confirmPaidTitle': '購入開通の確認',
  'pages.markets.confirmPaidDescription':
    'アプリ「{name}」（{price}）を購入しますか？レジに移動します。',
  'pages.markets.confirm': '確認',
  'pages.markets.cancel': 'キャンセル',
  'pages.markets.activateSuccess': 'アプリの開通に成功しました',
  'pages.markets.alreadyActive':
    'このアプリは現在のテナントですでに開通しています',
  'pages.markets.activateError':
    '開通に失敗しました。後でもう一度お試しください',
  'pages.markets.installSuccess': 'インストールに成功しました',
  'pages.markets.installError':
    'インストールに失敗しました。後でもう一度お試しください',
  'pages.markets.skillPackageMissing':
    'このスキルにはまだインストールパッケージがありません',
  'pages.markets.orderError':
    '注文の作成に失敗しました。後でもう一度お試しください',
  'pages.markets.contactReason':
    'このアプリを開通するには運営スタッフにお問い合わせください。',
  'pages.markets.unavailableUrl': '有効なアクセスURLが設定されていません',
  'pages.markets.close': '閉じる',
  'pages.markets.action.download': 'ダウンロード',
  'pages.markets.downloadError':
    'ダウンロードに失敗しました。しばらくしてから再試行してください',
  'pages.markets.pluginEngine': '対応エンジン',
  'pages.markets.pluginPermissions': '権限',
  'pages.markets.pluginNoPermissions': '追加の権限は不要',
  'pages.markets.pluginPermission.http': 'ネットワーク通信',
  'pages.markets.pluginPermission.commands': 'コマンド実行',
  'pages.markets.pluginPermission.storage': 'ローカルストレージ',
  'pages.markets.pluginPackageSize': 'パッケージサイズ',
  'pages.markets.pluginUpdatedAt': '更新日時',
  'pages.markets.pluginReadme': 'README',
  'pages.markets.pluginVersions': 'バージョン履歴',
  'pages.markets.pluginLatestTag': '現行版',
  'pages.markets.pluginDownloadLatest': '最新版をダウンロード',
};
